import React, { useState, useEffect } from "react";
import "./MainPage.css";
import IngredientList from "./components/IngredientList";
import RecipeList from "./components/RecipeList";
import { Flex } from "antd";
import common_axios from "./../commonAxios";

const MainPage = () => {

    const [ingredients, setIngredients] = useState([]);
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = () => {
        common_axios.get(`${process.env.REACT_APP_API_URL}/IngredientToUser/` + localStorage.getItem("userid"))
            .then(response => {
                setIngredients(response.data);
            })
            .catch(error => {
                console.error(error);
            });

        common_axios.get(`${process.env.REACT_APP_API_URL}/RecipeToUser/` + localStorage.getItem("userid"))
            .then(response => {
                setRecipes(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    return (
        <Flex className="">
            <div className="LeftHand">
                <IngredientList data={ingredients} changeMethod={() => loadData()} />
            </div>
            <div className="RightHand">
                <RecipeList data={recipes} changeMethod={() => loadData()} />
            </div>
        </Flex>
    );
};

export default MainPage;